/**
 * CSS custom property that AiComposerPopover sets on its floating element. It holds the height left
 * between the anchor and the bottom of the viewport; AiComposerSurface reads it to cap the popover.
 */
export const AI_COMPOSER_POPOVER_MAX_HEIGHT_VAR = '--ai-composer-popover-max-height';
